import styled, { css } from "styled-components"
import breakpoint from "styled-components-breakpoint"

export const GroupContainer = styled.div`
  display: flex;
  padding: 12px 26px;
  align-items: flex-end;
  gap: 50px;
  background-color: #f6f6f6;
  border-radius: 1rem;
  width: fit-content;
  margin-top: 16px;

  ${breakpoint("tablet")`
      gap: 72px;
      padding: 16px 36px;
    `}

  > div {
    position: relative;

    &:before {
      position: absolute;
      left: -25px;
      top: 0;
      bottom: 0;
      height: 100%;
      content: "";
      width: 1px;
      background-color: #ddd;

      ${breakpoint("tablet")`
          left: -36px;
        `}
    }

    &:first-child {
      &:before {
        display: none;
      }
    }
  }
`
